import { render, staticRenderFns } from "./ProjectTreeFileThumbnail.vue?vue&type=template&id=9e646db4&scoped=true&"
import script from "./ProjectTreeFileThumbnail.vue?vue&type=script&lang=js&"
export * from "./ProjectTreeFileThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e646db4",
  null
  
)

export default component.exports